import { render, staticRenderFns } from "./DangerDocReqPop.vue?vue&type=template&id=2f4ab3ca&scoped=true"
import script from "./DangerDocReqPop.vue?vue&type=script&lang=js"
export * from "./DangerDocReqPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4ab3ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4ab3ca')) {
      api.createRecord('2f4ab3ca', component.options)
    } else {
      api.reload('2f4ab3ca', component.options)
    }
    module.hot.accept("./DangerDocReqPop.vue?vue&type=template&id=2f4ab3ca&scoped=true", function () {
      api.rerender('2f4ab3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/DangerDocReqPop.vue"
export default component.exports